import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Customer } from 'app/models/customer.model';
import { User } from 'app/models/user.model';
import { environment } from 'environments/environment';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CustomerService {

  apiUrl: string = `${environment.apiUrl}customer`;

  constructor(private httpClient: HttpClient) { }

  getCustomers(){
    let enterprise: User = JSON.parse(sessionStorage.getItem('loggedUser'));
    return this.httpClient.get<Customer[]>(this.apiUrl + `?enterpriseId=${enterprise.databaseId}`);
  }

  getCustomer(){

  }

  saveCustomer(customer: Customer) : Observable<Customer>{
    if(customer.id){
      return this.httpClient.put<Customer>(this.apiUrl, customer).pipe(catchError(this.handleError));
    }else{
      return this.httpClient.post<Customer>(this.apiUrl, customer).pipe(catchError(this.handleError));
    }
  }

  inactiveCustomer(id: number){

  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong.
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
    }
    // Return an observable with a user-facing error message.
    return throwError(
      'Something bad happened; please try again later.');
  }
}
